<template>
	<div>
		<p>
		<button type="button" class="btn btn-primary" @click="addEvent">Добавить вебинар</button>
		</p>
    <div v-for="eventData in eventDatas" :key="eventData.id">
    Дополнительная новость № {{eventData.id}}
      <div class="row">
      <div class="col-md-3">
      <img :src="eventData.logo" width="100%">
      </div>
      <div class="col-md-5">
      <div class="input-group mb-1 mr-sm-2">
        <div class="input-group-prepend">
        <div class="input-group-text">Заголовок</div>
        </div>
        <input type="text" class="form-control" v-model="eventData.subject">
      </div>
      <div class="input-group mb-1 mr-sm-2">
        <div class="input-group-prepend">
        <div class="input-group-text">Ссылка</div>
        </div>
        <input type="text" class="form-control" v-model="eventData.url">
      </div>
			<div class="input-group mb-1 mr-sm-2">
				<div class="input-group-prepend">
				<div class="input-group-text">Текст</div>
				</div>
				<textarea type="text" class="form-control" v-model="eventData.text"></textarea>
			</div>
      <div class="form-group">
      <div class="custom-file">
          <input type="file"
            class="custom-file-input"
            :data-id="eventData.id"
            id="customFile"
            @change="onAttachmentChange"
          >
          <label class="custom-file-label" for="customFile">Выбрать фоновую картинку</label>
      </div>
    </div>
          Активирована <input type="checkbox"  true-value="1"  false-value="0" v-model="eventData.is_active">
          <br><br>
					Активирована для всех <input type="checkbox"  true-value="1"  false-value="0" v-model="eventData.fix">
      </div>
    </div>
    </div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			eventDatas: [],
			type: 2
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.getEvent()
	},
	methods: {
		getEvent () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/mailing/events/' + this.id + '?type=2', {}, {
			}).then(function (response) {
				this.eventDatas = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		addEvent: function () {
			const formData = new FormData()
			formData.append('id', this.id)
			formData.append('type', this.type)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailing/events', formData, {}, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
				const bodyData = response.body
				this.eventDatas.push(bodyData)
			}, function (response) {
			})
		},
		saveEvent: function () {
			let data = Object.assign({}, this.eventDatas)
			this.$store.commit('CALL_API_ON')
			this.$http.put(this.$store.state.apiURL + '/v1/mailing/events/' + this.id, data, {}, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onAttachmentChange (e) {
			var id = e.target.dataset.id
			if (e.target.files && e.target.files[0]) {
				var reader = new FileReader()
				this.eventDatas.forEach(eventData => {
					if (parseInt(id) === parseInt(eventData.id)) {
						reader.onload = function (e) {
							eventData.logo = e.target.result
						}
					}
				})
				reader.readAsDataURL(e.target.files[0])
			}
			this.attachment = e.target.files[0]
			const config = { 'content-type': 'multipart/form-data' }
			const formData = new FormData()
			formData.append('id', this.id)
			formData.append('type_id', id)
			formData.append('file', this.attachment)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailing/uploads', formData, config, {
			}).then(function (response) {
				this.headerImage = response.body.file_url
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		back () {
			history.back()
			return false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/Webinars.vue